import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer'
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer'
import { ISendMailConfig } from './sendMail/ISendMailConfig'


export class IrisrawModSendMail extends IrisModContainer<IrisConfigContainer<ISendMailConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModSendMail.createIrisSendMailConfig)        
    }

    static createIrisrawModSendMail(datas:IIrisModContainerConstParam) {        
        return new IrisrawModSendMail(datas)
    }

    static createIrisSendMailConfig(data:IIrisConfigContainerConstParam) {        
        return new IrisConfigContainer<ISendMailConfig>(data)
    }

}
